import { IDistributor } from "./index";

export const mockDistributorsData: IDistributor[] = [
  { id: "1", name: "Portland", image: "/images/attack-surface/integrations/generic2.svg" },
  { id: "2", name: "TechDistributor", image: "/images/attack-surface/integrations/generic.svg" },
  { id: "3", name: "Global Solutions", image: "/images/attack-surface/integrations/generic2.svg" },
  { id: "4", name: "Enterprise Partners", image: "/images/attack-surface/integrations/generic.svg" },
  { id: "5", name: "Cloud Distributors Inc", image: "/images/attack-surface/integrations/generic2.svg" },
];

